var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupSideMenuPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 4.99935C9.66667 3.1584 8.17427 1.66602 6.33333 1.66602C4.49239 1.66602 3 3.1584 3 4.99935C3 6.84028 4.49239 8.33268 6.33333 8.33268C8.17427 8.33268 9.66667 6.84028 9.66667 4.99935Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 13.0007C1.66602 10.4233 3.75536 8.33398 6.33268 8.33398C7.04842 8.33398 7.72648 8.49512 8.33268 8.78305",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 13.6668C12.7427 13.6668 13.3914 13.2612 13.736 12.6591M11.9992 13.6668C11.2558 13.6668 10.6071 13.2612 10.2624 12.6591M11.9992 13.6668V14.8668M13.736 12.6591L14.7992 13.2666M13.736 12.6591C13.9035 12.3667 13.9992 12.0279 13.9992 11.6668C13.9992 11.3056 13.9035 10.9667 13.7359 10.6742M10.2624 12.6591L9.19922 13.2666M10.2624 12.6591C10.0949 12.3667 9.99922 12.0279 9.99922 11.6668C9.99922 11.3056 10.095 10.9667 10.2625 10.6742M11.9992 9.6668C12.7426 9.6668 13.3912 10.0723 13.7359 10.6742M11.9992 9.6668C11.2559 9.6668 10.6072 10.0723 10.2625 10.6742M11.9992 9.6668V8.4668M13.7359 10.6742L14.7992 10.0666M10.2625 10.6742L9.19922 10.0666",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSideMenuPersonal);
export default __webpack_public_path__ + "static/media/group_side_menu_personal.3cfd37d5a3298aedd439c790be181e9b.svg";
export { ForwardRef as ReactComponent };